import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiEdit, FiTrash2, FiSearch, FiCalendar, FiPlus, FiX } from 'react-icons/fi';
import { database } from '../../Firebase';
import { ref, push, onValue, remove, update } from 'firebase/database';

const EmployeeSalaryInfo = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { grampanchayatName, arthikVarshLabel } = location.state || {};

    const [viewMode, setViewMode] = useState('list'); // 'list' or 'form'
    const [searchTerm, setSearchTerm] = useState('');
    const [salaryRecords, setSalaryRecords] = useState([]);
    const [persons, setPersons] = useState([]);

    // Form State
    const initialFormState = {
        month: 'जानेवारी',
        year: '2025',
        employeeId: '',
        employeeName: '',
        date: new Date().toISOString().split('T')[0],
        // Add other salary fields as needed (basic, HRA, etc.)
    };
    const [formData, setFormData] = useState(initialFormState);
    const [showEmployeeSelection, setShowEmployeeSelection] = useState(false);

    // Fetch Data
    useEffect(() => {
        const salaryRef = ref(database, 'Grampanchayat/Panipuravtha/EmployeeSalary');
        onValue(salaryRef, (snapshot) => {
            const data = snapshot.val();
            const loaded = [];
            if (data) Object.keys(data).forEach(key => loaded.push({ id: key, ...data[key] }));
            setSalaryRecords(loaded);
        });

        // Fetch Persons for Employee Dropdown
        const personsRef = ref(database, 'Grampanchayat/Panipuravtha/Persons');
        onValue(personsRef, (snapshot) => {
            const data = snapshot.val();
            const loaded = [];
            if (data) Object.keys(data).forEach(key => loaded.push({ id: key, ...data[key] }));
            setPersons(loaded);
        });
    }, []);

    const handleShow = () => {
        if (!formData.month || !formData.year) {
            alert('कृपया महिना आणि वर्ष निवडा');
            return;
        }
        setShowEmployeeSelection(true);
    };

    const handleSave = () => {
        if (!formData.employeeId) {
            alert('कृपया कर्मचारी निवडा');
            return;
        }

        const salaryRef = ref(database, 'Grampanchayat/Panipuravtha/EmployeeSalary');
        push(salaryRef, formData)
            .then(() => {
                alert('माहिती यशस्वीरित्या साठवली');
                setFormData(initialFormState);
                setShowEmployeeSelection(false);
                setViewMode('list');
            })
            .catch(err => alert(err.message));
    };

    // Modal for Person Selection
    const [isPersonModalOpen, setIsPersonModalOpen] = useState(false);
    const [modalSearch, setModalSearch] = useState('');

    const monthOptions = [
        "जानेवारी", "फेब्रुवारी", "मार्च", "एप्रिल", "मे", "जून",
        "जुलै", "ऑगस्ट", "सप्टेंबर", "ऑक्टोबर", "नोव्हेंबर", "डिसेंबर"
    ];

    return (
        <div className="min-h-screen bg-gray-50 p-4 md:p-6 font-poppins">
            
             {/* Person Modal */}
             {isPersonModalOpen && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl overflow-hidden animate-fade-in-up">
                        <div className="bg-blue-800 text-white p-3 flex justify-between items-center">
                            <h3 className="font-bold text-lg">कर्मचारी निवड</h3>
                            <button onClick={() => setIsPersonModalOpen(false)}><FiX size={24} /></button>
                        </div>
                        <div className="p-4">
                            <input type="text" placeholder="Search..." className="w-full border p-2 rounded mb-4" onChange={e => setModalSearch(e.target.value)} />
                            <div className="max-h-80 overflow-y-auto">
                                <table className="w-full text-sm text-left border-collapse border">
                                    <thead className="bg-blue-100">
                                        <tr><th className="p-2 border">Name</th><th className="p-2 border">Mobile</th></tr>
                                    </thead>
                                    <tbody>
                                        {persons.filter(p => (p.firstName + ' ' + p.surname).toLowerCase().includes(modalSearch.toLowerCase())).map(p => (
                                            <tr key={p.id} onClick={() => {
                                                setFormData(prev => ({...prev, employeeId: p.id, employeeName: `${p.firstName} ${p.surname}`}));
                                                setIsPersonModalOpen(false);
                                            }} className="cursor-pointer hover:bg-gray-100">
                                                <td className="p-2 border">{p.firstName} {p.fatherName} {p.surname}</td>
                                                <td className="p-2 border">{p.mobileNo}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-lg border border-blue-900 overflow-hidden">
                {/* Header */}
                <div className="bg-blue-800 text-white p-4 flex justify-between items-center">
                    <div className="flex items-center gap-2">
                        <button onClick={() => viewMode === 'form' ? (() => {setFormData(initialFormState); setShowEmployeeSelection(false); setViewMode('list');})() : navigate(-1)} className="bg-white/10 hover:bg-white/20 p-2 rounded-full mr-2"><FiArrowLeft /></button>
                        <h1 className="text-xl font-bold">कर्मचारी पगार माहिती</h1>
                    </div>
                    {viewMode === 'list' && (
                        <button onClick={() => setViewMode('form')} className="bg-green-600 px-6 py-1.5 rounded font-bold text-sm hover:bg-green-700 transition">नवीन</button>
                    )}
                </div>

                {viewMode === 'list' ? (
                    <div className="p-4">
                         <div className="flex gap-4 items-center bg-gray-50 p-3 rounded border border-gray-200 mb-4">
                            <label className="font-medium text-gray-700">व्यवहार दिनांक:</label>
                            <input type="date" className="p-1 border rounded" />
                            <button className="bg-green-600 text-white px-4 py-1 rounded text-sm font-bold">दाखवा</button>
                         </div>
                         <div className="flex gap-2 mb-4">
                            <input 
                                type="text" 
                                placeholder="शोधणे" 
                                className="flex-grow border p-2 rounded border-blue-300 focus:outline-none focus:ring-1 focus:ring-blue-500" 
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <button className="bg-green-600 text-white px-6 py-2 rounded font-bold hover:bg-green-700 transition">शोधणे</button>
                         </div>
                         
                         <div className="overflow-x-auto">
                             <table className="w-full text-sm text-center border-collapse">
                                <thead className="bg-[#2c5282] text-white">
                                    <tr>
                                        <th className="px-4 py-3 border-r border-blue-400">पगार व्यवहार क्र.</th>
                                        <th className="px-4 py-3 border-r border-blue-400 text-left">कर्मचारी नाव</th>
                                        <th className="px-4 py-3 border-r border-blue-400">महिना</th>
                                        <th className="px-4 py-3 border-r border-blue-400">वर्ष</th>
                                        <th className="px-4 py-3 border-r border-blue-400">दिनांक</th>
                                        <th className="px-4 py-3">पर्याय</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {salaryRecords.filter(r => r.employeeName?.toLowerCase().includes(searchTerm.toLowerCase())).length === 0 ? (
                                        <tr><td colSpan="6" className="p-4 text-gray-500">No records found</td></tr>
                                    ) : (
                                        salaryRecords.filter(r => r.employeeName?.toLowerCase().includes(searchTerm.toLowerCase())).map((r, idx) => (
                                            <tr key={r.id} className="hover:bg-blue-50">
                                                <td className="p-3 border-r">{idx + 1}</td>
                                                <td className="p-3 border-r font-medium text-blue-800 text-left">{r.employeeName}</td>
                                                <td className="p-3 border-r">{r.month}</td>
                                                <td className="p-3 border-r">{r.year}</td>
                                                <td className="p-3 border-r">{r.date}</td>
                                                <td className="p-3 flex justify-center gap-2">
                                                    <button className="text-blue-600 hover:text-blue-800"><FiEdit size={18} /></button>
                                                    <button className="text-red-500 hover:text-red-700"><FiTrash2 size={18} /></button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                             </table>
                         </div>

                        {/* Pagination */}
                        <div className="bg-gradient-to-b from-blue-700 to-blue-900 p-2 mt-4 flex justify-center gap-1 rounded-sm">
                             <button className="px-3 py-1 bg-blue-600 text-white rounded text-xs border border-blue-400">|&lt;</button>
                             <button className="px-3 py-1 bg-blue-600 text-white rounded text-xs border border-blue-400">&lt;&lt;</button>
                             <button className="px-3 py-1 bg-teal-600 text-white rounded text-xs border border-teal-400 font-bold">1</button>
                             <button className="px-3 py-1 bg-blue-600 text-white rounded text-xs border border-blue-400">&gt;&gt;</button>
                             <button className="px-3 py-1 bg-blue-600 text-white rounded text-xs border border-blue-400">&gt;|</button>
                             <select className="ml-2 py-0.5 px-1 rounded text-xs"><option>5</option></select>
                        </div>
                    </div>
                ) : (
                    <div className="p-8 md:px-20 bg-white">
                        <div className="space-y-6 max-w-4xl mx-auto border border-blue-400 rounded p-4">
                            
                            <div className="flex flex-wrap items-center justify-between gap-4 border-b border-blue-200 pb-4">
                                <div className="flex items-center gap-2">
                                    <label className="text-gray-700 font-medium">महिना:</label>
                                    <select 
                                        className="p-2 border border-blue-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 w-40"
                                        value={formData.month}
                                        onChange={(e) => setFormData({...formData, month: e.target.value})}
                                    >
                                        {monthOptions.map(m => <option key={m} value={m}>{m}</option>)}
                                    </select>
                                </div>
                                <div className="flex items-center gap-2">
                                    <label className="text-gray-700 font-medium">वर्ष:</label>
                                    <input 
                                        type="text" 
                                        className="p-2 border border-blue-300 rounded w-24 text-center focus:outline-none focus:ring-1 focus:ring-blue-500" 
                                        value={formData.year}
                                        onChange={(e) => setFormData({...formData, year: e.target.value})}
                                    />
                                </div>
                                <button 
                                    onClick={handleShow} 
                                    className="bg-green-600 text-white px-8 py-2 rounded font-bold hover:bg-green-700 transition"
                                >
                                    दाखवा
                                </button>
                            </div>

                            {showEmployeeSelection && (
                                <div className="space-y-6 animate-fade-in-down">
                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center bg-gray-100 p-2 rounded">
                                        <label className="text-right text-gray-700 md:col-span-1 font-medium">कर्मचारी नाव:</label>
                                        <div className="md:col-span-3">
                                            <div className="flex">
                                                <input 
                                                    type="text" 
                                                    placeholder="कर्मचारी नाव निवडा." 
                                                    className="w-full p-2 border border-blue-300 rounded-l focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white" 
                                                    value={formData.employeeName}
                                                    readOnly
                                                />
                                                <button 
                                                    onClick={() => setIsPersonModalOpen(true)}
                                                    className="bg-blue-800 text-white px-3 rounded-r hover:bg-blue-900 transition-colors"
                                                >
                                                    ...
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {/* Additional fields for Salary Details can go here */}
                                    
                                    <div className="flex justify-center gap-4 mt-8 pt-4">
                                        <button onClick={handleSave} className="bg-green-600 text-white px-8 py-2 rounded font-bold hover:bg-green-700 transition">साठविणे</button>
                                        <button onClick={() => {setFormData(initialFormState); setShowEmployeeSelection(false);}} className="bg-red-600 text-white px-8 py-2 rounded font-bold hover:bg-red-700 transition">रद्द करणे</button>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EmployeeSalaryInfo;
